<template>
  <el-upload
    multiple
    action=""
    class="mg-upload-button"
    :http-request="handleRequestUpload"
    :file-list="fileList"
    :auto-upload="true"
    :show-file-list="false"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot>
      <el-button type="primary">{{ uploadText }}</el-button>
    </slot>
  </el-upload>
</template>

<script>
  import OSS from 'ali-oss'
  import i18n from '@/locale'
  export default {
    name: 'MgUploadButton',
    model: {
      prop: 'fileList',
      event: 'change',
    },
    props: {
      fileList: {
        type: Array,
        default: () => [],
      },
      uploadText: {
        type: String,
        default: i18n.t('上传附件'),
      },
    },
    methods: {
      async handleRequestUpload(param) {
        this.$emit('startUpload')
        this.$MGUI.utils
          .getAliyunToken({ originName: param.file.name })
          .then(({ data }) => {
            const client = new OSS({
              accessKeyId: data.accessKeyId,
              accessKeySecret: data.accessKeySecret,
              // 从STS服务获取的安全令牌（SecurityToken）。
              stsToken: data.securityToken,
              // 填写Bucket所在地域。以华东1（杭州）为例，设置region为oss-cn-hangzhou。
              region: 'oss-' + data.regionId,
              // 填写Bucket名称，例如examplebucket。
              bucket: data.bucketName,
            })
            return client.multipartUpload(`${data.bucketDir}/${data.ossFileName}`, param.file).then(() => {
              return {
                uid: param.file.uid,
                name: data.originName,
                ossName: data.ossFileName,
                url: data.bucketHost + data.bucketDir + '/' + data.ossFileName,
                remark: data.originName,
                appendixAddress: data.ossFileName,
              }
            })
          })
          .then((file) => {
            this.$emit('change', this.fileList.concat(file))
            this.$emit('uploadSuccess')
          })
      },
    },
  }
</script>
<style lang="scss">
  .mg-upload-button {
    text-align: center;
    display: flex;
  }
  .mg-upload-button + .el-button,
  .el-button + .mg-upload-button {
    margin-left: 10px;
  }
</style>
